import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { SystemaccountAction } from 'src/actions/systemaccount.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getSystemaccountStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

const SystemaccountLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedSystemaccountIds, setSelectedSystemaccountIds] = useState([]);
  const { items, total, filter } = useSelector(state => state.systemaccount);
  const [limit, setLimit] = useState(filter && typeof filter.limit !== 'undefined' ? filter.limit : DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(filter && typeof filter.page !== 'undefined' ? filter.page : 0);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const payload = {
      ...filter,
      page: page,
      limit: limit,
    };

    dispatch(SystemaccountAction.updateFilter(payload));
    dispatch(SystemaccountAction.list());
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedSystemaccountIds;

    if (event.target.checked) {
      newSelectedSystemaccountIds = items.map((systemaccount) => systemaccount.id);
    } else {
      newSelectedSystemaccountIds = [];
    }

    setSelectedSystemaccountIds(newSelectedSystemaccountIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSystemaccountIds.indexOf(id);
    let newSelectedSystemaccountIds = [];

    if (selectedIndex === -1) {
      newSelectedSystemaccountIds = newSelectedSystemaccountIds.concat(selectedSystemaccountIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSystemaccountIds = newSelectedSystemaccountIds.concat(selectedSystemaccountIds.slice(1));
    } else if (selectedIndex === selectedSystemaccountIds.length - 1) {
      newSelectedSystemaccountIds = newSelectedSystemaccountIds.concat(selectedSystemaccountIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSystemaccountIds = newSelectedSystemaccountIds.concat(
        selectedSystemaccountIds.slice(0, selectedIndex),
        selectedSystemaccountIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSystemaccountIds(newSelectedSystemaccountIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, systemaccount) => {
    setSelected(systemaccount);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(SystemaccountAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(SystemaccountAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 0 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Đăng nhập vào
                </TableCell>
                <TableCell>
                  Chức năng
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.slice(page * limit, page * limit + limit).map((systemaccount, index) => (
                <TableRow
                  hover
                  key={systemaccount.id}
                  selected={selectedSystemaccountIds.indexOf(systemaccount.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {systemaccount.position}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(systemaccount.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, systemaccount)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.ten_goi_cuoc} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default SystemaccountLookupDetail;
